import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {UtilityState} from "./UtilityState";
import {UTILITIES_FETCHED, UTILITY_CREATED, UTILITY_UPDATED, UTILITY_DELETED} from "../../action/utility/actionType";

const initState: UtilityState = {
	utilities: none
};

const reducer = handleActions({
	[UTILITIES_FETCHED]: (state: UtilityState,
		action: Action<any>): UtilityState => {
		return {...state, utilities: option(action.payload.utilities)}
	},
	[UTILITY_CREATED]: (state: UtilityState,
		action: Action<UTILITY_CREATED>): UtilityState => {
		const utilities = [...state.utilities.getOrElse([]), action.payload.utility];
		return {...state, utilities: option(utilities)}
	},
	[UTILITY_UPDATED]: (state: UtilityState,
		action: Action<UTILITY_UPDATED>): UtilityState => {
		const utilities = state.utilities.getOrElse([]).map(
			u => u.id == action.payload.utility.id ? action.payload.utility : u);
		return {...state, utilities: option(utilities)}
	},
	[UTILITY_DELETED]: (state: UtilityState,
		action: Action<UTILITY_DELETED>): UtilityState => {
		const utilities = state.utilities.getOrElse([]).filter(
			u => u.id !== action.payload.utilityId);
		return {...state, utilities: option(utilities)}
	},
}, initState);

export default reducer;